import React from 'react'

import Modal from '../UI/Modal/Modal'
import Button from '../UI/Button/Button'

import classes from './ConfirmationModal.scss'
import { withTranslate } from 'react-redux-multilingual'

const confirmationModal = ({ confirmed, cancelled, open, header, promptText, translate }) => {
  const buttonGroups = (
    <div className={classes.ButtonGroup}>
      <span className={classes.Button}>
        <Button color={'secondary'} clicked={confirmed}>
          {translate('confirm')}
        </Button>
      </span>
      <span className={classes.Button}>
        <Button color={'inherit'} clicked={cancelled}>
          {translate('cancel')}
        </Button>
      </span>
    </div>
  )
  return (
    <Modal
      open={open}
      onHide={cancelled}
      size={'xs'}
      header={header || translate('confirmDel')}
      footer={buttonGroups}>
      <div className={classes.TextWrapper}>{promptText}</div>
    </Modal>
  )
}

export default withTranslate(confirmationModal)
